import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-1923">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-1924">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-1925">
          High Speed Milling & Diamond Saw
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-1926">
          Dust-Free Graphite Mills & Diamond Abrasive Cutting
        </p>
      </div>
    </div>;
}